module.exports = __webpack_public_path__ + "static/media/chromeQR.ac9bb31b.png";